import { createSlice } from "@reduxjs/toolkit";
import VwIslemtanimRaporDTO from "src/models/Settings/VwIslemtanimRaporDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export interface IIslemTanimRaporState {
    islemId: number,
    islemAdi: string,
    activeRow: VwIslemtanimRaporDTO,
    open: boolean
}

const IslemTanimRaporSlice = createSlice<IIslemTanimRaporState, MapReducerPayloads<IIslemTanimRaporState, {
    setState: IIslemTanimRaporState,
}>>({
    name: 'IslemTanimRapor',
    initialState: {
        islemId: null,
        activeRow: new VwIslemtanimRaporDTO(),
        open: false,
        islemAdi: ""
    },
    reducers: {
        setState: (state, action) => action.payload
    }
})
export default IslemTanimRaporSlice;